// Espelho de api/src/services/evolution/assessmentProtocols.js — usado só para
// PREVIEW do %G enquanto o personal digita; o backend é a fonte da verdade.

export const POLLOCK7_FOLDS = [
  'peitoral',
  'axilarMedia',
  'triceps',
  'subescapular',
  'abdominal',
  'suprailiaca',
  'coxa',
];

export const FOLD_LABELS = {
  peitoral: 'Peitoral',
  axilarMedia: 'Axilar média',
  triceps: 'Tríceps',
  subescapular: 'Subescapular',
  abdominal: 'Abdominal',
  suprailiaca: 'Supra-ilíaca',
  coxa: 'Coxa',
};

const round1 = (n) => Math.round(n * 10) / 10;
const clamp = (pct) => round1(Math.min(60, Math.max(3, pct)));

export function previewBodyFat({ protocol, sex, ageYears, heightCm, weightKg, inputs = {} }) {
  try {
    if (protocol === 'pollock7') {
      const values = POLLOCK7_FOLDS.map((k) => Number(inputs.folds?.[k]));
      if (!sex || !ageYears || values.some((v) => !v || v <= 0)) return null;
      const S = values.reduce((a, b) => a + b, 0);
      const D =
        sex === 'masculino'
          ? 1.112 - 0.00043499 * S + 0.00000055 * S * S - 0.00028826 * ageYears
          : 1.097 - 0.00046971 * S + 0.00000056 * S * S - 0.00012828 * ageYears;
      return clamp(495 / D - 450);
    }
    if (protocol === 'weltman') {
      const a1 = Number(inputs.abdomen1Cm);
      const a2 = Number(inputs.abdomen2Cm);
      const w = Number(weightKg);
      if (!sex || !a1 || !a2 || !w) return null;
      const abd = (a1 + a2) / 2;
      if (sex === 'masculino') return clamp(0.31457 * abd - 0.10969 * w + 10.8336);
      const h = Number(heightCm);
      if (!h) return null;
      return clamp(0.11077 * abd - 0.17666 * h + 0.14354 * w + 51.03301);
    }
    const pct = Number(inputs.bodyFatPct);
    return pct > 0 ? clamp(pct) : null;
  } catch {
    return null;
  }
}

export const ageFromBirthdate = (birthdate) => {
  if (!birthdate) return null;
  const b = new Date(birthdate);
  const now = new Date();
  let age = now.getFullYear() - b.getFullYear();
  if (now.getMonth() < b.getMonth() || (now.getMonth() === b.getMonth() && now.getDate() < b.getDate())) age -= 1;
  return age > 0 ? age : null;
};
